import React from 'react';
import {IconToggle, Text} from 'wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {classes} from './BottomFoldableSummarySection.st.css';
import ChevronUp from 'wix-ui-icons-common/on-stage/ChevronUp';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';

export enum BottomFoldableSummarySectionDataHooks {
  root = 'BottomFoldableSummarySectionDataHooks.root',
  content = 'BottomFoldableSummarySectionDataHooks.content',
  chevronUp = 'BottomFoldableSummarySectionDataHooks.chevronUp',
  chevronDown = 'BottomFoldableSummarySectionDataHooks.chevronDown',
}

export interface BottomFoldableSummarySectionProps {
  onClick: () => void;
  isOpen: boolean;
}

export const BottomFoldableSummarySection = ({onClick, isOpen}: BottomFoldableSummarySectionProps) => {
  const localeKeys = useLocaleKeys();
  const {
    checkoutStore: {checkout},
  } = useControllerProps();
  return (
    <button
      type={'button'}
      data-hook={BottomFoldableSummarySectionDataHooks.root}
      className={classes.root}
      onClick={onClick}
      aria-expanded={isOpen}>
      <Text data-hook={BottomFoldableSummarySectionDataHooks.content}>
        {isOpen
          ? localeKeys.checkout.mobile.hideItems.label({number: checkout.numberOfItems})
          : localeKeys.checkout.mobile.showItems.label({number: checkout.numberOfItems})}
      </Text>
      <IconToggle
        icon={<ChevronDown data-hook={BottomFoldableSummarySectionDataHooks.chevronDown} />}
        checkedIcon={<ChevronUp data-hook={BottomFoldableSummarySectionDataHooks.chevronUp} />}
        checked={isOpen}
      />
    </button>
  );
};
